import type { RouteLocationNormalized } from 'vue-router';
import { useStartupData } from '@/composables/useStartupData';
import { useAuthStore } from '@/stores/auth';

export const preloadUserInfo = async (to: RouteLocationNormalized) => {
  const isLoaded = await useStartupData().loadUser(to.fullPath);

  if (!isLoaded && useAuthStore().isAuthorized.value) {
    return false;
  }
};
